import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { createprovider  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class CreateProvider extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[]
    }

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
   

  }


  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };


  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{

    let req = JSON.stringify({
        name:this.state.name,
        email: this.state.email,
        password:this.state.password,
        status:this.state.status
    })
    
    createprovider(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('created provider successfully', 'Create Provider');

        setTimeout(function () {
          window.location.replace('/wiseconnect/listproviders');
         }, 1000);

      }else{
            
        NotificationManager.error('Error creating a provider', 'Create Provider');
      }

    });
}

 
  
 
  render() {
 const {value, suggestions, pickedones} = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                  <h4 class="card-title">Create Provider</h4>
                 
                    <div class="postajobform wc">

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Name </label>
<input type="text" class="form-control forminputcls" id="name" name="name"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Email </label>
<input type="email" class="form-control forminputcls" id="email" name="email"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Password </label>
<input type="text" class="form-control forminputcls" id="password" name="password"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Status </label>
  <select name="status" class="form-control selectdropdowns" onChange={this.handleChange}>
          <option value="">select status</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
          <option value="2">Waiting</option>
  </select>
</div> 

<div class="formgroup text-center paddingtop20">
<button type="button" name="postajob" class="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
</div> 

</div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default CreateProvider;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/createprovider.jsx